export const MODULE = "new/stripeIntegrationTile";
